import { UPDATE_TYPE } from '@/model/universe-update/types'

export default {
    close: 'close dialog',
    actions: {
        forward: 'Continue',
        back: 'Back',
        adminBackend: 'Trend management',
        close: 'Close'
    },
    [UPDATE_TYPE.INTRODUCED_MEGATREND]: {
        headline: 'New Mega-trends',
        text: 'These mega-trends have been added to the trend universe.'
    },
    [UPDATE_TYPE.REVISED_MEGATREND]: {
        headline: 'Modified Mega-trends',
        text: 'These mega-trends have been updated regarding recent developments. A new version has been made available for activation.'
    },
    [UPDATE_TYPE.INTRODUCED]: {
        headline: 'New Macro-trends',
        text: 'These macro-trends have been added to the trend universe.'
    },
    [UPDATE_TYPE.REVISED]: {
        headline: 'Modified Macro-trends',
        text: 'These macro-trends have been updated regarding recent developments. A new version has been made available for activation.'
    },
    [UPDATE_TYPE.REPLACED]: {
        headline: 'Replaced Macro-trends',
        text: 'These macro-trends have evolved significantly, giving rise to new macro-trends.'
    },
    [UPDATE_TYPE.MERGED]: {
        headline: 'Merged Macro-trends',
        text: 'These macro-trends are expiring and will be included in an existing macro-trend.'
    }
}
